<div [formGroup]="form">
  @if (form.get('idTipoProduto')?.value === _tipoProdutoEnum.Kit) {
  <div class="section-container" id="kits">
    <div class="section-title">
      <mat-icon>layers</mat-icon>
      <span>Composição do Kit</span>
    </div>
    <div class="row align-items-start">
      <div class="col-12 col-md-5">
        <div class="toggle-content">
          <mat-slide-toggle class="app-toggle-compact" formControlName="isPrecoKitFixo">Preço Fixo</mat-slide-toggle>
          <span class="info-text">{{ precoFixoHint }}</span>
        </div>
      </div>
      @if (isPrecoKitFixo) {
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Preço de venda no kit</mat-label>
          <input matInput formControlName="precoKitFixo" [currencyMask]="defaultCurrencyMask" />
        </mat-form-field>
      </div>
      }
    </div>
    <div formArrayName="composicao">
      <div class="grid-header">
        <p>Itens do Kit</p>
        <div class="grid-buttons-flex">
          <button mat-button class="grid-buttons" type="button" (click)="atualizarPesoKit()">
            <mat-icon class="material-symbols-outlined">monitor_weight</mat-icon> Atualizar peso
          </button>
          <button mat-button class="grid-buttons" type="button" (click)="addComposicaoRow()">
            <mat-icon class="material-symbols-outlined">add</mat-icon> Adicionar
          </button>
        </div>
      </div>
      @for (item of composicao.controls; track item; let i = $index) {
      <div [formGroupName]="i">
        <div class="row margin-bottom-50">
          <div class="col-10 col-md-11">
            <div class="row">
              <div class="col-12 col-lg-5">
                <app-select-pesquisavel [apiUrl]="urlProduto" [control]="getControl(item, 'idProdutoFilho')"
                  idField="idProduto" nameField="descricao" label="Produto" placeholder="Pesquise o produto..."
                  [preloadedOptions]="item.get('preloadedList')?.value" [hint]="
                        item.get('skuProdutoFilho')?.value ? 'SKU: ' + item.get('skuProdutoFilho')?.value : ''
                      " (selectionChange)="onProdutoKitSelected($event, i)">
                </app-select-pesquisavel>
              </div>
              <!-- Quantidade -->
              <div class="col-4 col-lg-2">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Quantidade</mat-label>
                  <input matInput formControlName="quantidade" [currencyMask]="quantidadeMask" />
                </mat-form-field>
                <!-- Indicador do múltiplo (RN05): nada aparece se o componente não tem múltiplo -->
                @if (!getMultiploStatus(item).semMultiplo) {
                @if (getMultiploStatus(item).valido) {
                <div class="kit-multiplo-ok">
                  = {{ getQuantidadeEmMultiplos(item) | abnt: 'quantidade' }} {{ item.get('unidadeMultiplo')?.value }}
                </div>
                } @else {
                <div class="kit-multiplo-erro">
                  {{ item.get('nomeProdutoFilho')?.value }} é vendido em {{ item.get('unidadeMultiplo')?.value }} de
                  {{ item.get('fatorMultiplo')?.value | abnt: 'quantidade' }}. Informe uma quantidade múltipla de
                  {{ item.get('fatorMultiplo')?.value | abnt: 'quantidade' }}.
                </div>
                }
                }
              </div>
              <!-- Preço Unitário / Custo -->
              <div class="col-4 col-lg-2">
                <strong>Valor unitário no kit</strong>
                <div>{{ getUnitarioNoKit(item) | abnt: 'preco' }}</div>
                <div class="small">
                  {{
                  getCustoLabel(item.get('precoCusto')?.value, item.get('custoMedio')?.value)
                  | abnt: 'preco'
                  }}
                </div>
              </div>
              <!-- Preço Total -->
              <div class="col-4 col-lg-2">
                <strong>Valor total no kit</strong>
                <div>{{ getTotalNoKit(item) | abnt: 'preco' }}</div>
              </div>
            </div>
          </div>
          <!-- Delete -->
          <div class="col-2 col-md-1 produto-grid-delete-col">
            <button mat-icon-button class="delete-button produto-grid-delete-button" type="button"
              (click)="removeComposicaoRow(i)" matTooltip="Remover">
              <mat-icon class="material-symbols-outlined">delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      }
      @if (composicao.length === 0) {
      <app-empty-state icon="layers" title="Nenhum item adicionado ao kit."
        subtitle="Adicione os produtos que compõem este kit e suas quantidades.">
      </app-empty-state>
      }
      <!-- Alerta agregado: enquanto existir, o Salvar fica desabilitado (RN06) -->
      @if (componentesForaDoMultiplo > 0) {
      <app-alert-card type="warning" [title]="'Quantidade fora do múltiplo'">
        {{ alertaMultiploTexto }}
      </app-alert-card>
      }
    </div>
    <!-- Totalização -->
    <div class="totalizacao-card mt-3">
      <div class="row g-2">
        <div class="col-12 col-lg-5">
          <span class="totalizacao-label">TOTALIZAÇÕES</span>
        </div>
        <div class="col-4 col-lg-2">
          <span class="totalizacao-label">Qtd total</span>
          <div>{{ totalQuantidadeKit | abnt: 'quantidade' }}</div>
        </div>
        <div class="col-4 col-lg-2">
          <span class="totalizacao-label">Preço de venda no kit</span>
          <div>{{ totalPrecoVendaKit | abnt: 'preco' }}</div>
          <div class="small fw-normal">{{ getCustoTotalLabel(totalCustoMedioKit) | abnt: 'preco' }}</div>
        </div>
        <div class="col-4 col-lg-2">
          <span class="totalizacao-label">Valor de venda no kit</span>
          <div>{{ totalPrecoGeralKit | abnt: 'preco' }}</div>
        </div>
      </div>
    </div>
  </div>
  }
</div>